export default {
  toasts: {
    failed_to_delete_website: 'Websitet kunne ikke slettes',
    website_deleted: 'Websitet er slettet',
  },
  delete_model: {
    title: 'Er du sikker på, at du vil slette websitet?',
    confirm: 'Slet',
    cancel: 'Annuller',
  },
  buttons: {
    open_editor: 'Åbn editor',
    transfer_website: 'Overfør website',
    delete_site: 'Slet',
  },
};
